import env from "react-dotenv";
import {
    Card,
    CardBody,
    CardFooter,
    Typography,
    Button,
  } from "@material-tailwind/react";
import { Box } from "@mui/material";

const UserPermissionPage = () => {

    const profilePageRedirect = () =>{
        window.location.href = env.IAAM_HOST
    }

    return (
        <div className="flex justify-center h-screen w-screen bg-[conic-gradient(at_bottom_left,_var(--tw-gradient-stops))] from-blue-200 to-blue-900">
            <Card className="lg:w-2/6 lg:mt-14 mt-6 w-96">
                <CardBody>
                    <Box 
                        component='img'
                        className="h-12 w-12 mb-6" 
                        alt="candice" 
                        src="/images/Watch-Logo-Color.png"
                    />
                    <Typography variant="h5" color="blue-gray" className="mb-2 font-primary text-left">
                    ท่านไม่ได้รับอนุญาติให้เข้าใช้งาน
                    </Typography>
                    <Typography className="font-primary font-normal text-left">
                        บัญชีของท่านยังไม่ได้รับอนุญาตให้เข้าใช้งานแอปพลิเคชัน<span className="text-blue-900">ทันระบาดติดตาม</span> 
                    </Typography>
                </CardBody>
                <CardFooter className="pt-0">
                    <Button className="font-primary float-left" onClick={()=> profilePageRedirect()}>รายละเอียด</Button>
                </CardFooter>
            </Card>
        </div>
    )
}

export default UserPermissionPage;